import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ExceptionService, PaginatedList, UtilsService } from '../../xform-compat';
import { RmsBasicCrudService } from '../components/rms-basic-crud.service';
import { PublicCompanyDashboardModel } from '../../shared/models/company/public-company-dashboard.model';
import { StormDashboardModel } from '../../shared/models/company/storm-dashboard.model';
import { ExecDashboardRequestBody } from '../../shared/models/exec-dashboard-request-body.model';
import { StormDashboardRequestBody } from '../../shared/models/storm-dashboard-request-body.model';


/**
 * Service to handle exec dashboard API integration
 */
@Injectable({
  providedIn: 'root'
})
export class ExecDashboardService extends RmsBasicCrudService<any> {

  constructor(
    http: HttpClient,
    utilsService: UtilsService,
    exceptionService: ExceptionService
  ) {
    super(http, utilsService, exceptionService);
  }

  /**
   * Get the filtered list or default list for exec dashboard
   * @param body
   * @param params
   */
  public getDashboardData (body: any, params: {page: number, pagesize: number}): Observable<PaginatedList<PublicCompanyDashboardModel>> {
    return super.saveData(`/api/rms/companies/dashboard/public?page=${params.page}&pagesize=${params.pagesize}`, body);
  }

  /**
   * Get the total of list for exec dashboard
   */
   public getDashboardTotal (): Observable<number> {
    const body = { active: true, isDeleted: false };
    return super.saveData(`/api/rms/companies/dashboard/public/count?`, body);
  }

  /**
   * Get the filtered list or default list for storm dashboard
   * @param body
   * @param params
   */
    public getStormDashboardData (body: any, params: {page: number, pagesize: number}): Observable<PaginatedList<StormDashboardModel>> {
      return super.saveData(`/api/rms/companies/dashboard/storm?page=${params.page}&pagesize=${params.pagesize}`, body);
    }

  /**
   * Get possible values from the storm dashboard index
   */
    public getStormDashboardFieldValues (field: string): Observable<Array<string>> {
      return super.getData(`/api/rms/companies/dashboard/storm/index/values/${field}`);
    }

    /**
     * Get the total of list for storm dashboard
     */
     public getStormDashboardTotal (body?): Observable<number> {
      body = { ... body, active: true, isDeleted: false};
      return super.saveData(`/api/rms/companies/dashboard/storm/count?`, body);
    }

  /**
   * Export the public company dashboard as a CSV blob based on the given filter.
   * The backend embeds the applied-filter summary at the top of the CSV.
   */
  public exportPublicDashboard(body: ExecDashboardRequestBody, params?: any): Observable<Blob> {
    return super.getHttp().post('/api/rms/companies/dashboard/public/export', body, { responseType: 'blob', params: params });
  }

  /**
   * Export the storm (private) company dashboard as a CSV blob based on the given filter.
   * The backend embeds the applied-filter summary at the top of the CSV.
   */
  public exportStormDashboard(body: StormDashboardRequestBody, params?: any): Observable<Blob> {
    return super.getHttp().post('/api/rms/companies/dashboard/storm/export', body, { responseType: 'blob', params: params });
  }

}
